import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnInit, AfterViewInit {

  @ViewChild('icon') _icon!: ElementRef;
  @ViewChild('message') _message!: ElementRef;
  @ViewChild('arrow') _arrow!: ElementRef;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.calculatePosition();
  }
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    this.calculatePosition();
  }
  showMessage = false;
  dir = 'rtl';
  ngOnInit(): void {
    this.dir = document.querySelector('html')?.dir || 'ltr';
  }

  get icon() {
    return this._icon.nativeElement;
  }

  get message() {
    return this._message.nativeElement;
  }

  get arrow() {
    return this._arrow.nativeElement;
  }

  ngAfterViewInit() {
    this.calculatePosition();
  }

  toggle() {
    this.showMessage = !this.showMessage;
  }

  calculatePosition() {
    let rect = this.icon.getBoundingClientRect();
    let height = this.message.offsetHeight;
    let width = this.message.offsetWidth;
    if (width >= document.body.clientWidth * 0.9) {
      width = document.body.clientWidth * 0.9;
    }
    let offsetStart;
    let offsetEnd;
    let direction; // 1 goleft , 2 goright
    if (this.dir == 'ltr') {
      offsetStart = rect.left;
      offsetEnd = document.body.clientWidth - rect.right;
      if (offsetStart < offsetEnd) {
        direction = 2;
      } else direction = 1;
    } else {
      offsetStart = rect.right;
      offsetEnd = rect.left;
      if (offsetStart > offsetEnd) {
        direction = 2;
      } else direction = 1;
    }

    if (window.innerHeight - (rect.top + 19) >= height + 5) {
      this.arrow.classList.remove('up');
      this.arrow.classList.add('down');
    } else {
      this.arrow.classList.remove('down');
      this.arrow.classList.add('up');
    }
    let fraction = width * 0.2;
    let diff;

    if (direction == 1) {
      diff = (fraction > offsetEnd ? offsetEnd : fraction) - width;
      let screenRestiriction = width * 0.8 - offsetStart;

      if (screenRestiriction < 0) screenRestiriction = 0;
      this.message.style.insetInlineStart = `${
        diff + screenRestiriction - 7
      }px`;
    } else {
      let screenRestiriction = width * 0.8 - offsetEnd;

      if (screenRestiriction < 0) screenRestiriction = 0;
      diff = width - (fraction > offsetStart ? offsetStart : fraction);
      this.message.style.insetInlineStart = 'unset';
      this.message.style.insetInlineEnd = `${-diff + 7 + screenRestiriction}px`;
    }
  }
}
